import { observer } from "mobx-react";
import React, { useEffect, useState } from 'react';
import styles from "./index.module.scss";
import { useTranslation } from 'react-i18next';

const Faq = observer(() => {
    const { t } = useTranslation();
    const [faqArray, setFaqArray] = useState();
    const [faqsOpen, setFaqsOpen] = useState([]);

    const faqHandler = (i) => {
        if (faqsOpen.indexOf(i) === -1) {
            setFaqsOpen([...faqsOpen, i]);
        } else {
            setFaqsOpen(faqsOpen.filter(val => val !== i));
        }
    }

    useEffect(() => {
        fetch("https://api.nftendo.net/api/faqs")
            .then(response => response.json())
            .then(data => { setFaqArray(data) })
    }, [])

    return (
        <div id="faq" name="faq" className={styles["faq"]}>
            <div className={styles["faq__container"]}>
                <h2 data-aos="fade-right">{t("faq.title")}</h2>
                {faqArray && faqArray.data.map((item, i) => {
                    return (
                        <div data-aos-delay={100 * i} data-aos="fade-down" key={i} className={styles["faq__wrapper"]} >
                            <div className={styles["faq__title"]} onClick={() => faqHandler(i)}>
                                {item.attributes.Title}
                            </div>
                            {faqsOpen.includes(i) &&
                                <div className={styles["faq__description"]}>
                                    {item.attributes.Description}
                                </div>}
                        </div>
                    )
                })}
            </div>
        </div>
    )
});

export default Faq;
